export enum HgPriceType {
  NET = 'net',
  GROSS = 'gross',
  EXTRA = 'extra',
}
